var map = {
	"./0x81e277e85924b9ffb681c33bbfbf177446f22f0e7584caca7b6f6d75d529c06e.json": 7225,
	"./0xbd50b1c7f37e1340d0fdce4f7b9c7ce373a6b43625cf892b6b19e9e0de955343.json": 5063
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6285;